import {Component, Inject, ViewChild} from "@angular/core";
import {BlobId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {faMobileAlt} from "@fortawesome/pro-solid-svg-icons";
import {FileUpload} from "primeng/fileupload";
import {AssetAndBlobApi} from "@webmate-web-core/shared/api/rest/assetAndBlob.restapi";
import {take} from 'rxjs/operators';
import {ModalToolContainerService, WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';

export class BlobUploadToolConfig implements WebmateToolConfig {
    toolName = "Upload File";
    scrollable = false;
    accept: string = "";

    constructor(public projectId: ProjectId, public createCallback: (blobId: BlobId) => void, accept?: string) {
        if (accept) {
            this.accept = accept;
        }
    }
}

@Component({
    selector: 'wm-blob-upload-tool',
    templateUrl: './blob-upload-tool.component.html',
    styleUrls: ['./blob-upload-tool.component.less']
})
export class BlobUploadToolComponent {
    mobile = faMobileAlt;

    @ViewChild("fileUpload", {read: FileUpload})
    uploader: FileUpload;

    file: any;

    uploading = false;
    finishedUploads = [];
    accept: string;

    constructor(@Inject(TOOL_CONTAINER_DATA) private data: BlobUploadToolConfig, private blobApi: AssetAndBlobApi, private toolService: ModalToolContainerService) {
        this.accept = data.accept;
    }

    cancel() {
        this.reset();
        this.toolService.closeLastTool();
    }

    reset() {
        this.file = undefined;
        this.uploading = false;
        this.finishedUploads = [];
    }

    selectFile(event: Event) {
        const target = event.target as HTMLInputElement;
        const files = target.files as FileList;
        Array.from(files).forEach(f => this.setFile(f));
    }

    dropFile(event: File[]) {
        event.forEach(f => {
            this.setFile(f);
        });
    }

    setFile(f: File) {
        const reader = new FileReader();
        reader.onload = (e) => {
            this.file = {
                url: reader.result,
                file: f
            };
        };
        reader.readAsDataURL(f);
    }

    deleteFile() {
        this.file = undefined;
    }

    upload(event: MouseEvent) {
        if (this.uploading) {
            return;
        }
        this.uploading = true;
        this.blobApi.putBlob(this.file.file, this.data.projectId).pipe(take(1)).subscribe(blobId => {
            this.reset();
            this.data.createCallback(blobId);
            this.toolService.closeLastTool();
        });
        event.stopPropagation();
    }
}
